export const truncateText = (text, max = 30) => (text?.length > max ? `${text.substring(0, max)}...` : text ?? "");
